import React from "react";

export default function FSection(props) {
  return (
    <div className="flex sm:flex-row flex-col gap-x-5 gap-y-5 border border-gray-200 p-4">
      <div className="self-center">
        <img
          src={props.img}
          alt="logo-1"
          className="md:max-w-[80px] max-w-[60px]"
        />
      </div>
      <div className="space-y-2">
        <h3 className="text-themeBlue font-bold sm:text-2xl text-xl sm:text-start text-center">
          {props.title}
        </h3>
        <p className="font-normal sm:text-base text-sm text-black text-opacity-60 sm:text-start text-center">
          {props.desc}
        </p>
      </div>
    </div>
  );
}
